<template>
    <div class="nav-phone" :class="{loading: loading}">
        <modal :name=modalId
               :adaptive="true"
               :maxWidth="420"
               height="auto">
            <div class="dashboard-block">
                <header>
                    Make Outgoing Call
                    <a href="javascript://void" class="back" @click="closeModal">Close</a>
                </header>

                <form @submit.prevent="call" accept-charset="UTF-8" novalidate="novalidate">
                    <div class="has-feedback"
                         :class="{'has-error': errors.has('project_id')}">
                        <label for="project-id">From Number</label>

                        <select id="project-id"
                                v-model="project_id"
                                name="project_id"
                                class="form-control"
                                aria-required="true">
                            <option v-for="(value, label) in phoneOptions" :value="value" :key="value">
                                {{label}}
                            </option>
                        </select>

                        <span v-show="errors.has('project_id')" class="help-block">
                            {{ errors.first('project_id') }}
                        </span>
                    </div>


                    <div class="form-group has-feedback"
                         :class="{'has-error': errors.has('to')}">
                        <label for="to">Phone Number</label>

                        <input id="to"
                               type="tel"
                               v-model="to"
                               name="to"
                               class="form-control"
                               aria-required="true">

                        <span v-show="errors.has('cleanedTo')" class="help-block">
                            {{ errors.first('cleanedTo') }}
                        </span>
                    </div>

                    <input id="cleaned-to"
                           type="hidden"
                           v-validate="'required|phone'"
                           v-model="cleanedTo"
                           name="cleanedTo">
                    <hr>

                    <div class="row">
                        <div class="col-xs-6 form-group pull-right">
                            <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                Connect
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            modalId: {
                default(){
                    return _.uniqueId( 'modal_' );
                },
                type: String
            },
        },

        data(){
            return {
                loading: false,
                to: null,
                project_id: null,
                projects: []
            };
        },

        computed: {
            cleanedTo(){
                if( this.to ){
                    return this.to.replace( /\D/g, '' );
                }

                return null;
            },

            form(){
                var form = document.createElement( 'form' );
                form.setAttribute( 'method', 'POST' );
                form.setAttribute( 'action', '/calls' );

                var hiddenField = document.createElement( 'input' );
                hiddenField.setAttribute( 'type', 'hidden' );
                hiddenField.setAttribute( 'name', '_method' );
                hiddenField.setAttribute( 'value', 'POST' );

                var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
                var tokenField = document.createElement( 'input' );
                tokenField.setAttribute( 'type', 'hidden' );
                tokenField.setAttribute( 'name', '_token' );
                tokenField.setAttribute( 'value', token );

                form.appendChild( tokenField );
                form.appendChild( hiddenField );

                let data = {
                    'Call': {
                        'to': this.to,
                        'project_id': this.project_id
                    }
                    
                };

                const map = {
                    'to': this.to,
                    'project_id': this.project_id,
                };

                _.each( map, ( value, callIndex ) => {
                    if( !_.isNil( value ) ){
                        let field = document.createElement( 'input' );
                        field.setAttribute( 'type', 'hidden' );
                        field.setAttribute( 'name', 'Call[' + callIndex + ']' );
                        field.setAttribute( 'value', value );
                        form.appendChild( field );
                    }
                } );

                return form;
            },

            phoneOptions(){
                let result = {
                    'Default': null
                };
                
                _.each( this.projects, ( project ) => {
                    result[ project.name ] = project.id;
                } );

                return result;
            },
        },

        created(){
            this.init();
        },

        methods: {
            init(){
                this.loading = true;

                return this.loadProjects()
                    .catch( this.$root.handleErrors )
                    .finally( () => {
                        this.loading = false;
                    } );
            },

            call(){
                return this.$validator.validateAll()
                    .then( ( valid ) => {
                        if( valid ){
                            this.loading = true;

                            const form = this.form;

                            document.body.appendChild( form );
                            form.submit();
                        }
                    } );
            },

            loadProjects(){
                var url = '/api/projectsPhoneList';

                return axios.get( url )
                    .then( ( response ) => {
                        var projects = _.sortBy( response.data.Projects, 'name' );

                        this.$set( this, 'projects', projects );
                    } );
            },

            closeModal(){
                this.$modal.hide( this.modalId );
            },

            openModal(){
                this.$modal.show( this.modalId );
            },
        }
    }
</script>
